import React from "react";

const ChevronDown = ({ disabled, width = 24, height = 24, stroke = "#2D2C44", strokeOpacity = .7, strokeWidth = 2, style, ...rest }) => <svg
  {...rest}
  style={style}
  xmlns="http://www.w3.org/2000/svg" width={width} height={height}
  viewBox={`0 0 ${width} ${height}`} fill="none">
  <path
    d="M7 10L12 15L17 10"
    stroke={stroke} strokeOpacity={disabled ? .24 : strokeOpacity} strokeWidth={strokeWidth} strokeLinecap="round"
    strokeLinejoin="round" />
</svg>
  ;

export default ChevronDown;
